import { Space } from 'antd';
import moment from 'moment';

import { formatAndLocaleDate } from '../../../common/helpers/formatAndLocaleDate';

import style from '../orderCreateHeader.module.scss';

type TProps = {
    /** Даты заказа приходят строками — `moment` разбирает их сам */
    startDate: string | null;
    endDate: string | null;
    onStartClick: () => void;
    onEndClick: () => void;
};

export const OrderDateRange = ({ startDate, endDate, onStartClick, onEndClick }: TProps) => {
    return (
        <div className={style['order-date-wrapper']}>
            <div className={style['order-date']}>
                <div style={{ flexGrow: '1' }}>
                    <Space>
                        <span>Запись с</span>
                        <div className={style['custom-date-picker']} onClick={onStartClick}>
                            {formatAndLocaleDate(moment(startDate), true)}
                        </div>
                    </Space>
                </div>

                <div className={style['end-date']}>
                    <Space>
                        <span>по</span>
                        <div className={style['custom-date-picker']} onClick={onEndClick}>
                            {endDate ? formatAndLocaleDate(moment(endDate), true) : '- / -'}
                        </div>
                    </Space>
                </div>
            </div>
        </div>
    );
};
